import _ from 'lodash';

const validate = (questions) => {
    if (!_.isEmpty(questions)) {
        const rootVisibleList = _.filter(questions,
            (question) => _.isUndefined(question.isRootVisible));
        const questionsRootVisibleValid = _.some(rootVisibleList,
            (question) => ((_.has(question, 'value')
            && !_.isBoolean(question.value)) ? (question.value === '' || question.value === null) : false));
        let questionsRootInVisibleValid = false;
        const rootInVisibleList = _.filter(questions,
            (question) => question.isRootVisible && question);
        if (!_.isEmpty(rootInVisibleList)) {
            const visibleRootValue = (code) => _.find(questions, (question) => {
                return question.code === code;
            }).value;
            questionsRootInVisibleValid = _.some(rootInVisibleList,
                (question) => ((_.has(question, 'value') && visibleRootValue(_.get(question, 'visible')) === true
                        && !_.isBoolean(question.value)) ? (question.value === '' || question.value === null) : false));
        }

        const questionListWithoutCheckboxGroup = _.filter(questions, (question) => {
            return question.optionType !== 'checkboxgroup'
            && (question.type === 'title' || _.get(question, 'value', false)) && question;
        });

        const questionListWithoutCheckboxGroupValid = _.some(questionListWithoutCheckboxGroup,
            (question) => {
                const options = _.get(question, 'options');
                return _.some(options, (option) => (option.value === '' || option.value === null));
            });

        const cascadingFieldList = _.some(questions, (question) => {
            const options = _.get(question, 'options');
            const checkboxFieldListWithSelected = (question.optionType === 'checkboxgroup') && (_.isUndefined(question.value) || question.value === true) && _.filter(options, (option) => {
                return option.type === 'CheckboxField'
                && typeof _.get(option, 'code') === 'string' && option.hasValue && _.get(option, 'value', false) && option;
            }).map((item) => item.code);
            if (!_.isEmpty(checkboxFieldListWithSelected)) {
                return _.some(options, (option) => {
                    return _.includes(checkboxFieldListWithSelected, option.visible) && (option.value === '' || option.value === null);
                });
            }
            return false;
        });
        const checkBoxGroupLength = _.filter(questions, (question) => {
            return (question.optionType === 'checkboxgroup') && (_.isUndefined(question.value) || question.value === true);
        }).length;
        const chkBoxGrpOptionSelectionLength = _.filter(questions, (question) => {
            const options = _.get(question, 'options');
            return (question.optionType === 'checkboxgroup') && (_.isUndefined(question.value) || question.value === true)
             && _.some(options, (option) => option.type === 'CheckboxField' && option.value === true);
        }).length;
        const chkboxGrpSingleOptionValid = checkBoxGroupLength === chkBoxGrpOptionSelectionLength;
        return !questionsRootVisibleValid && !questionsRootInVisibleValid
        && chkboxGrpSingleOptionValid
        && !questionListWithoutCheckboxGroupValid && !cascadingFieldList;
    }
    return false;
};

export default { validate };
